import React, { useMemo } from 'react';

import { isProtectedData } from 'pages/item/v2/components/ProtectedData';
import isEmpty from 'utils/is-empty';

import Link from '../Link';
import TablePanel from '../TablePanel';

interface VulnersCpeMatch {
    vulnerable: boolean;
    versionStartIncluding: string;
    versionEndIncluding: string;
    criteria: string;
}

export interface VulnersCpeProps {
    vulnersCpe:
        | {
              configuration: {
                  operator: string;
                  nodes: {
                      operator: string;
                      cpeMatch: VulnersCpeMatch[];
                  }[];
              };
              cpe_tokens: string[];
          }
        | undefined;
}

const VulnersCpe: React.FC<VulnersCpeProps> = ({ vulnersCpe }) => {
    const cpeList = useMemo(
        () =>
            vulnersCpe?.configuration?.nodes
                ?.reduce((acc, node) => {
                    const cpeMatch = node.cpeMatch.map((item) => item.criteria);
                    return [...acc, ...cpeMatch];
                }, [])
                .map((item) => {
                    const parts = item.split(':');
                    return {
                        vendor: isProtectedData(item) ? item : parts[3] ?? '',
                        product: isProtectedData(item) ? item : parts[4] ?? '',
                        version: isProtectedData(item) ? item : parts[5]?.replace(/\\/g, '') ?? '',
                        cpe: item
                    };
                }),
        [vulnersCpe]
    );

    if (isEmpty(vulnersCpe?.configuration?.nodes)) {
        return null;
    }

    return (
        <TablePanel
            data={cpeList}
            config={[
                {
                    name: 'Vendor',
                    sortField: 'vendor',
                    field({ vendor }) {
                        return (
                            <Link
                                href={`/search?query=enchantments.vulners_cpe_configuration.cpe_tokens:*${vendor}*`}
                                label={vendor}
                            />
                        );
                    }
                },
                {
                    name: 'Product',
                    sortField: 'product',
                    field({ vendor, product }) {
                        return (
                            <Link
                                href={`/search?query=enchantments.vulners_cpe_configuration.cpe_tokens:*${vendor}:${product}*`}
                                label={product}
                            />
                        );
                    }
                },
                {
                    name: 'Version',
                    sortField: 'version',
                    field: 'version'
                },
                {
                    name: 'CPE',
                    sortField: 'cpe',
                    field: 'cpe'
                }
            ]}
        />
    );
};

export default VulnersCpe;
